import { Component, Input } from '@angular/core';
import { ChoiceInputComponent } from '../choice-input/choice-input.component';
import { getFirstError } from '../../forms/validation';
import { InputErrors } from '../../forms/errors';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss'],
  standalone: false
})
export class SelectInputComponent<T> extends ChoiceInputComponent<T> {
  @Input()
  public placeholder = 'Please make a selection...';

  @Input()
  public validation = true;

  @Input()
  public canSelectPlaceholder = false;

  @Input()
  public errors: InputErrors = { required: 'This field is required' };

  public inputId = `input-${uuidv4()}`;

  public get showError(): boolean {
    return this.control.touched && !!this.control.errors && !!this.errorPresentation;
  }

  public get errorPresentation(): string | null {
    const firstError = getFirstError(this.control);
    if (!firstError) {
      return null;
    }

    const errorMessage = this.errors[firstError];
    if (typeof errorMessage === 'function') {
      return errorMessage(this.control.getError(firstError));
    } else {
      return errorMessage ?? null;
    }
  }
}
